import { system } from './theme'
import { grayRamp, blueRamp } from './tokens'

/**
 * [Spec §4.3/§5.4] MapLibre paint needs literal colours, so the walk map's palette is resolved
 * from theme tokens HERE (the theme directory is the style ratchet's colour home) and never typed
 * as hex in a component. Same meanings as the list rows: accent = still to do, warning = revisit,
 * muted = done. The map is light in both colour modes (A6 rule), so these are light values.
 *
 * gray/blue are mode-aware semantic tokens (dualRamp in theme.ts), so `system.token` returns a
 * CSS var for them, which MapLibre cannot paint. Those resolve from their LIGHT base ramps.
 */
const LIGHT_RAMPS: Record<string, Record<string | number, string>> = { gray: grayRamp, blue: blueRamp }

const color = (token: string): string => {
  const [palette, step] = token.split('.')
  const v = (step !== undefined ? LIGHT_RAMPS[palette]?.[step] : undefined) ?? system.token(`colors.${token}`)
  if (typeof v !== 'string' || !v.startsWith('#')) throw new Error(`walkMapColors: no hex for ${token}`)
  return v
}

export const WALK_MAP_COLORS = {
  untouched: color('brand.500'),
  revisit: color('yellow.500'),
  done: color('gray.400'),
  ghost: color('gray.300'),
  pinStroke: color('white'),
  label: color('white'),
  route: color('brand.400'),
  nextSegment: color('brand.700'),
  selectedRing: color('gray.900'),
  gps: color('blue.500'),
} as const
